import {
  ACTION_CREATE_PROMOTION_CODE,
  ACTION_DELETE_PROMOTION_CODE,
  ACTION_FETCH_PROMOTION_CODES,
} from '@/store/actions.type';
import { MUTATION_SET_PROMOTION_CODES } from '@/store/mutations.type';
import PromotionProxy from '@/proxies/promotion.proxy';

const state = {
  promotionCodes: [],
  paging: {},
};

const getters = {
  promotionCodes: (state) => state.promotionCodes,
  pagingPromotionCodes: (state) => state.paging,
};

const actions = {
  [ACTION_FETCH_PROMOTION_CODES]({ commit }, query = {}) {
    return PromotionProxy.promotionCodes(query).then((response) => {
      commit(MUTATION_SET_PROMOTION_CODES, response.data);
      return response;
    });
  },
  [ACTION_CREATE_PROMOTION_CODE](context, payload) {
    return PromotionProxy.createPromotionCode(payload);
  },
  [ACTION_DELETE_PROMOTION_CODE](context, id) {
    return PromotionProxy.deletePromotionCode(id);
  },
};

const mutations = {
  [MUTATION_SET_PROMOTION_CODES](state, payload = {}) {
    state.promotionCodes = payload.rows || [];
    state.paging = payload;
  },
};

export default { state, getters, actions, mutations };
